import YesNoToggleMedicalQuestion from "../Components/YesNoToggleMedicalQuestion";
import ComposableMedicalFormEvaluator, {
  IComposableMedicalFormEvaluatorConfig
} from "../Types/ComposableMedicalFormEvaluator";
import IMedicalFormElementProps from "../Types/IMedicalFormElement";
import IMedicalQuestionnaireCompleteEvaluator from "../Types/IMedicalQualificationCompleteEvaluator";
import IMedicalQualificationNonCandidateEvaluator from "../Types/IMedicalQualificationNonCandidateEvaluator";

const questionIds = {
  diabetic: "generalMedicalQuestions.dialysis",
  oxygen: "generalMedicalQuestions.oxygen",
  organTransplant: "generalMedicalQuestions.organTransplant",
  bleedingDisorder: "generalMedicalQuestions.bleedingDisorder",
  bloodClot: "generalMedicalQuestions.bloodClot"
};

const diabeticQuestion: React.FC<IMedicalFormElementProps> = props =>
  YesNoToggleMedicalQuestion({
    ...props,
    questionId: questionIds.diabetic,
    text: "Are you on Dialysis?",
    ChildFormItem: null
  });

const oxygenQuestion: React.FC<IMedicalFormElementProps> = props =>
  YesNoToggleMedicalQuestion({
    ...props,
    questionId: questionIds.oxygen,
    text: "Do you use an oxygen tank while awake?",
    ChildFormItem: null
  });

const organTransplantQuestion: React.FC<IMedicalFormElementProps> = props =>
  YesNoToggleMedicalQuestion({
    ...props,
    questionId: questionIds.organTransplant,
    text: "Have you had an organ transplant or are you currently on the organ transplant waiting list?",
    ChildFormItem: null
  });

const bleedingDisorderQuestion: React.FC<IMedicalFormElementProps> = props =>
  YesNoToggleMedicalQuestion({
    ...props,
    questionId: questionIds.bleedingDisorder,
    text: "Do you have a bleeding disorder?",
    ChildFormItem: null
  });

const bloodClotQuestion: React.FC<IMedicalFormElementProps> = props =>
  YesNoToggleMedicalQuestion({
    ...props,
    questionId: questionIds.bloodClot,
    text: "Have you had a blood clot in the last 12 months?",
    ChildFormItem: null
  });

/** Configuration for the general questions medical form evaluator. */
export const GeneralMedicalQuestionsEvaluatorConfig: IComposableMedicalFormEvaluatorConfig = {
  allFormQuestionIds: Object.values(questionIds),
  requiredQuestionPredicates: null,
  nonCandidateIgnoredQuestionIds: null,
  nonCandidateQuestionPredicates: null
};

/** Evaluator for the general questions medical form. */
export const GeneralMedicalQuestionsEvaluator: IMedicalQuestionnaireCompleteEvaluator &
  IMedicalQualificationNonCandidateEvaluator = new ComposableMedicalFormEvaluator(
  GeneralMedicalQuestionsEvaluatorConfig
);

/** The fully composed questions for the Medical Step showing general medical history questions. */
export const ComposedGeneralMedicalQuestions: React.FC<IMedicalFormElementProps>[] = [
  diabeticQuestion,
  oxygenQuestion,
  organTransplantQuestion,
  bleedingDisorderQuestion,
  bloodClotQuestion
];
